module.exports = __webpack_public_path__ + "static/media/investment.b4ba742e.svg";